import { memberId } from '@trello/session-cookie';
import { Storage } from '@trello/storage';
import { ActionStorage } from './action-history';
import { HistoryEntry } from './types';
import { cleanHistory } from './clean-history';

const STORAGE_KEY = memberId ? `action_history_${memberId}` : undefined;

export const localActionStorage: ActionStorage = {
  read() {
    return STORAGE_KEY ? cleanHistory(Storage.get(STORAGE_KEY)) : [];
  },

  write(history: HistoryEntry[]) {
    if (STORAGE_KEY) {
      Storage.set(STORAGE_KEY, history);
    }
  },
};
